import React, { useEffect } from "react";
import classNames from "classnames";

/**
 * The object tools are the edit and content management links
 * for the "object" you are currently viewing.
 * ie. the Apt or Agent whose URL you are currently on.
 *
 * This is included in the UserMenu component.
 *
 * The data is rendered as JSON data attributes in the HTML by Django
 */
export default function ObjectTools() {
  const [objectTools, setObjectTools] = React.useState([]);
  const [mobileShow, setMobileShow] = React.useState(false);
  useEffect(() => {
    const json =
      window.document.getElementById("object-tools")?.dataset?.objectTools;
    if (json) {
      setObjectTools(JSON.parse(json));
    }
  }, []);

  if (!objectTools?.length) {
    return null;
  }

  return (
    <ul className={classNames("ns-object-tools text-sm", { show: mobileShow })}>
      <div className="md:hidden object-tools-toggle">
        <i
          className="fas fa-cog"
          onClick={() => {
            setMobileShow(!mobileShow);
          }}
        />
      </div>
      {objectTools.map((item, i) => (
        <Item key={item.url ?? String(i)} {...item} />
      ))}
    </ul>
  );
}

function SubItem(props) {
  return (
    <li className={classNames({ active: props.active })}>
      <a href={props.url}>
        <i className={props.icon} /> {props.title}
      </a>
    </li>
  );
}

function Item(props) {
  const subs = props.submenu ? (
    <ul className="object-tools__submenu">
      {props.submenu.map((sub, i) => {
        return <SubItem key={sub.url ?? String(i)} {...sub} />;
      })}
    </ul>
  ) : null;

  return props.html != null ? (
    <li
      className={classNames({ active: props.active, header: props.submenu })}
      dangerouslySetInnerHTML={{ __html: props.html }}
    />
  ) : (
    <li className={classNames({ active: props.active, header: props.submenu })}>
      <a href={props.url} className="object-tools__header">
        <i className={props.icon} /> {props.title}
      </a>
      {subs}
    </li>
  );
}
